/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import s from './BreadCrumb.scss';

class BreadCrumb extends React.Component {
  getItem = item =>
    item.link && (
      <div
        itemscope="itemscope"
        itemtype="https://schema.org/ListItem"
        itemprop="itemListElement"
        key={item.id}
        className={s.item}
      >
        <>
          <Link
            to={item.link}
            itemprop="item"
            spa={item.spa === 'yes'}
            data-ga={`ATF_breadcrumb|${item.label}|`}
            ga4Data={[
              {
                event: 'user_click',
                type: 'breadcrumb',
                category: item.label,
              },
            ]}
          >
            <span itemprop="name">{item.label}</span>
          </Link>
          {/* {typeof index !== 'undefined' && (
            <meta content={index + 1} itemprop="position" />
          )} */}
        </>
      </div>
    );

  render() {
    const { data, title, wrapperClass, isPrimeContent } = this.props;
    const titleItem = {
      label: title,
    };
    if (data instanceof Array) {
      return (
        <div className={s[wrapperClass]}>
          {isPrimeContent && <span className={s.toiplusLogo} />}
          <div
            className={s.text_info}
            itemtype="https://schema.org/BreadcrumbList"
            itemscope=""
          >
            {data.map((item, index) => this.getItem(item, index))}
            {titleItem.label && this.getItem(titleItem)}
          </div>
        </div>
      );
    } else if (isPrimeContent) {
      return (
        <div className={s[wrapperClass]}>
          <span className={s.toiplusLogo_perp} />
        </div>
      );
    }
    return null;
  }
}

BreadCrumb.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  title: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
  isPrimeContent: PropTypes.bool,
};
BreadCrumb.defaultProps = {
  wrapperClass: '',
  isPrimeContent: false,
};
export default BreadCrumb;
